<script setup lang="ts">
import TBase from './TBase.vue';
import type { TypographyBaseProps } from './types';

defineOptions({
  name: 'CustomFig',
});

const props = withDefaults(defineProps<TypographyBaseProps>(), {
  fontFamily: 'BMWTypeNext',
  size: 14,
  color: 'inherit',
  weight: 300,
  onClick: undefined,
});
</script>

<template>
  <TBase v-bind="props">
    <slot />
  </TBase>
</template>
